<template>
  <div>
    <nav>
      <ul class="nav nav-tabs">
        <li
          v-for="tab in tabs"
          :key="tab"
          class="nav-item custom-tab"
        >
          <button
            class="nav-link btn border"
            :class="[ isActive(tab) ? 'btn-success' : 'btn-link' ]"
            :disabled="isActive(tab)"
            @click="validateTab(tab)"
          >
            {{ tab }}
          </button>
        </li>
      </ul>
    </nav>
    <button
      v-show="value === 'Basic'"
      class="btn btn-sm custom-button"
      :class="[{'btn-danger': isSave}, {'btn-light': !isSave}]"
      @click="save"
    >Save</button>
  </div>
</template>
<script>
export default {
  name: 'contact-tabs',
  props: {
    value: String,
    tabs: Array,
    isSave: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    status: {
      get() {
        return this.value
      }
    }
  },
  methods: {
    isActive(tab) {
      let status = this.status || ''
      return status.toUpperCase() === tab.toUpperCase()
    },
    validateTab(tab) {
      this.$emit('validate', tab)
    },
    setTab(tab) {
      this.$emit('change', tab)
    },
    save() {
      this.$emit('save')
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-tab {
  position: relative;
}
button {
  padding: 13px 25px;
}
button:disabled {
  opacity: 1;
}
.custom-button {
  position: absolute;
  right: 60px;
  top: 5px;
  padding: 0.25rem 0.5rem;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/tabs/contact-tabs.vue